<template>
  <div class="relative overflow-hidden skeleton-loader">
    <div class="shimmer absolute top-0 right-0 bottom-0 left-0" />
    <slot />
  </div>
</template>
